"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseButton = void 0;
const React = __importStar(require("react"));
const PromiseButton = React.memo(({ onClick, className, disabled, ...otherProps }) => {
    const [bDisabled, setDisabled] = React.useState(disabled);
    const [bPromise, setPromise] = React.useState(false);
    React.useEffect(() => {
        if (bDisabled !== disabled) {
            setDisabled(disabled);
        }
    }, [disabled]);
    async function handleClick(e) {
        if (!bDisabled && !bPromise) {
            setPromise(true);
            try {
                await onClick(e);
                setPromise(false);
            }
            catch (e) {
                setPromise(false);
            }
        }
    }
    return (React.createElement("button", Object.assign({ className: `${className} promise-button ${bPromise ? 'promise-button--waiting' : ''}`, disabled: bDisabled, onClick: handleClick }, otherProps), otherProps.children));
});
exports.PromiseButton = PromiseButton;
